// استيراد دوال React لإدارة الحالات والتأثيرات الجانبية
import { useEffect, useState } from "react";
// استيراد روابط API الخاصة بالمنتجات
import { Pro, PRO } from "../../../API/Api";
// استيراد كائن Axios المهيأ
import { Axios } from "../../../API/Axios";
// استيراد أيقونة الإضافة من Font Awesome
import { faPlus } from "@fortawesome/free-solid-svg-icons";
// استيراد مكون عرض الأيقونات
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// استيراد Link للتنقل بين الصفحات
import { Link } from "react-router-dom";
// استيراد مكون عرض الجدول
import TableShow from "../../../components/Dashboard/Table";
// استيراد سياق اللغة
import { useLanguage } from "../../../Context/LanguageContext";
// استيراد ملف الأنماط
import "../../../components/Dashboard/FormPage.css";

// المكون الرئيسي لإدارة المنتجات
export default function Products ()
{
    // استيراد دالة الترجمة من سياق اللغة
    const { t } = useLanguage();
    // حالة لتخزين قائمة المنتجات
    const [ products, setProducts ] = useState( [] );
    // حالة لتحديد عدد العناصر في الصفحة الواحدة
    const [ limit, setLimit ] = useState( 5 );
    // حالة لتحديد رقم الصفحة الحالية
    const [ page, setPage ] = useState( 1 );
    // حالة التحميل
    const [ loading, setLoading ] = useState( false );
    // حالة لتخزين العدد الإجمالي للمنتجات
    const [ total, setTotal ] = useState( 0 );

    // تأثير جانبي لجلب بيانات المنتجات عند تغيير الصفحة أو الحد
    useEffect( () =>
    {
        // تفعيل حالة التحميل
        setLoading( true );
        // إرسال طلب GET لجلب المنتجات مع معلمات الترقيم
        Axios.get( `/${ PRO }?limit=${ limit }&page=${ page }` )
            .then( ( res ) =>
            {
                // تخزين بيانات المنتجات
                setProducts( res.data.data );
                // تخزين العدد الإجمالي
                setTotal( res.data.total );
            } )
            .catch( ( error ) => console.log( "Error fetching products:", error ) ) // معالجة الأخطاء
            .finally( () => setLoading( false ) ); // إلغاء حالة التحميل في النهاية
    }, [ limit, page ] ); // إعادة التشغيل عند تغيير الحد أو الصفحة

    // تعريف أعمدة الجدول مع الترجمة
    const header = [
        { key: "title", name: t( 'products.columnTitle' ) }, // عمود العنوان
        { key: "images", name: t( 'products.columnImages' ) }, // عمود الصور
        { key: "description", name: t( 'products.columnDescription' ) }, // عمود الوصف
        { key: "price", name: t( 'products.columnPrice' ) }, // عمود السعر
        { key: "rating", name: t( 'products.columnRating' ) }, // عمود التقييم
        { key: "created_at", name: t( 'products.columnCreated' ) }, // عمود تاريخ الإنشاء
        { key: "updated_at", name: t( 'products.columnUpdated' ) }, // عمود تاريخ التحديث
    ];

    // دالة غير متزامنة لحذف منتج
    async function handleDelete ( id )
    {
        try
        {
            // إرسال طلب DELETE لحذف المنتج
            await Axios.delete( `/${ Pro }/${ id }` );
            // تحديث قائمة المنتجات بحذف المنتج المحدد
            setProducts( ( prev ) => prev.filter( ( item ) => item.id !== id ) );
        } catch ( error )
        {
            // طباعة خطأ الحذف في وحدة التحكم
            console.log( "Error deleting product:", error );
        }
    }

    // عرض واجهة إدارة المنتجات
    return (
        <div className="list-page-card"> {/* بطاقة صفحة القائمة */ }
            <div className="list-page-header"> {/* رأس الصفحة */ }
                <h2 className="list-page-title">{ t( 'products.pageTitle' ) }</h2> {/* عنوان الصفحة المترجم */ }
                {/* زر إضافة منتج جديد */ }
                <Link className="list-page-add-btn" to="/dashboard/products/add">
                    <FontAwesomeIcon icon={ faPlus } /> {/* أيقونة الإضافة */ }
                    <span>{ t( 'products.addButton' ) }</span> {/* نص الزر المترجم */ }
                </Link>
            </div>

            {/* مكون عرض الجدول مع تمرير الخصائص */ }
            <TableShow
                header={ header } // أعمدة الجدول
                data={ products } // بيانات المنتجات
                delete={ handleDelete } // دالة الحذف
                limit={ limit } // عدد العناصر في الصفحة
                page={ page } // الصفحة الحالية
                setpage={ setPage } // دالة تغيير الصفحة
                setLimit={ setLimit } // دالة تغيير الحد
                loading={ loading } // حالة التحميل
                total={ total } // العدد الإجمالي
                search="title" // حقل البحث
                searchLinck={ Pro } // رابط البحث
            />

            {/* تذييل الصفحة */ }
            <footer className="list-page-footer">
                <p className="m-0">{ t( 'footer.rights' ) }</p> {/* نص حقوق الملكية المترجم */ }
            </footer>
        </div>
    );
}